import { DEFAULT_FOCUS, useImageFocus } from "@/lib/imageFocus";

/** Image that honours the admin-selected framing (focal point or "show complete"). */
export const SmartImage = ({ src, alt = "", className = "", style, focusKey, ...rest }) => {
  const { focusOf } = useImageFocus();
  const focus = focusOf(focusKey || src);
  const contain = focus === "contain";
  return (
    <img
      src={src}
      alt={alt}
      className={`${className} ${contain ? "bg-[#EFEAE0]" : ""}`}
      style={{
        objectFit: contain ? "contain" : "cover",
        objectPosition: contain ? "center" : focus || DEFAULT_FOCUS,
        ...style,
      }}
      {...rest}
    />
  );
};

export default SmartImage;

/** Natural-size image that switches to a framed crop only when a framing was saved. */
export const FramedImage = ({ src, alt = "", className = "", frame = "aspect-[4/3]", ...rest }) => {
  const { focusOf } = useImageFocus();
  if (!focusOf(src)) return <img src={src} alt={alt} className={className} {...rest} />;
  return (
    <div className={`${frame} w-full overflow-hidden`}>
      <SmartImage src={src} alt={alt} className="h-full w-full" {...rest} />
    </div>
  );
};
